/**
 * AllAll Sora 2：图片转视频，FormData 提交
 * 参数：model=sora-2, prompt, seconds, input_reference(File 必填), size(1280x720|720x1280), watermark, private?, character_url?, character_timestamps?
 */
function normalizeSeconds(n) {
  var num = parseInt(n, 10)
  if (isNaN(num)) return 8
  if (num <= 4) return 4
  if (num <= 6) return 6
  return 8
}

function normalizeSize(v) {
  var s = (v || '16:9').replace(/：/g, ':').trim()
  return s === '9:16' ? '720x1280' : '1280x720'
}

/**
 * 构建 AllAll Sora 2 POST /v1/videos 的 FormData（仅图片转视频，调用方需保证 referenceImage 为 File）
 * @param {Object} params - prompt, videoDuration?, aspectRatio?, referenceImage(File 必填), watermark?, private?, characterUrl?, characterTimestamps?
 */
export function buildFormData(params) {
  var form = new FormData()
  form.append('model', 'sora-2')
  form.append('prompt', (params.prompt || '').trim().slice(0, 2000))
  form.append('seconds', String(normalizeSeconds(params.videoDuration || params.length || 8)))
  form.append('size', normalizeSize(params.aspectRatio))
  form.append('watermark', params.watermark === true ? 'true' : 'false')
  form.append('private', params.private === true ? 'true' : 'false')
  if (params.referenceImage && typeof File !== 'undefined' && params.referenceImage instanceof File) {
    form.append('input_reference', params.referenceImage, params.referenceImage.name || 'image.jpg')
  }
  if (params.characterUrl && typeof params.characterUrl === 'string' && params.characterUrl.trim()) {
    form.append('character_url', params.characterUrl.trim())
  }
  if (params.characterTimestamps && typeof params.characterTimestamps === 'string' && params.characterTimestamps.trim()) {
    form.append('character_timestamps', params.characterTimestamps.trim())
  }
  return form
}
